<template>
  <div class="meta-data" v-if="metaInfoList != null && metaInfoList.length > 0">
    <table>
      <caption class="ir">메타정보테이블</caption>
      <colgroup>
        <col>
        <col>
      </colgroup>
      <tbody>
        <tr v-for="(data, idx) in nonEmptyMetaInfoList" v-bind:key="idx">
          <th scope="row">{{ data.metaKorNm }}</th>
          <td v-html="data.metaContents"></td>
        </tr>
      <!-- <tr>
        <th scope="row">통계명</th>
        <td v-html="statisticsName"></td>
      </tr>
      <tr>
        <th scope="row">현재자료기준연도</th>
        <td v-html="statisticsBaseYear"></td>
      </tr>
      <tr>
        <th scope="row">입력예정연도</th>
        <td v-html="statisticsInputYear"></td>
      </tr>
      <tr>
        <th scope="row">통계종류</th>
        <td v-html="statisticsType"></td>
      </tr>
      <tr>
        <th scope="row">법적근거</th>
        <td v-html="statisticsReason"></td>
      </tr>
      <tr>
        <th scope="row">조사목적</th>
        <td v-html="statisticsPurpose"></td>
      </tr>
      <tr>
        <th scope="row">조사주기</th>
        <td v-html="statisticsTerm"></td>
      </tr>
      <tr>
        <th scope="row">조사대상</th>
        <td v-html="statisticsTarget"></td>
      </tr>
      <tr>
        <th scope="row">조사방법</th>
        <td v-html="statisticsMethod"></td>
      </tr>
      <tr>
        <th scope="row">조사기간</th>
        <td v-html="statisticsPeriod"></td>
      </tr>
      <tr>
        <th scope="row">조사내용</th>
        <td v-html="statisticsContent"></td>
      </tr>
      <tr>
        <th scope="row">작성체계</th>
        <td v-html="statisticsRule"></td>
      </tr>
      <tr>
        <th scope="row">최신자료</th>
        <td v-html="statisticsMaterial"></td>
      </tr>
      <tr>
        <th scope="row">자료검색</th>
        <td v-html="statisticsPublish"></td>
      </tr>
      <tr>
        <th scope="row">담당기관</th>
        <td v-html="statisticsOrganization"></td>
      </tr>
      <tr>
        <th scope="row">이용시 유의점</th>
        <td v-html="statisticsNotice"></td>
      </tr> -->
      </tbody>
    </table>
  </div>
</template>

<script>
import * as api from "@/api/Statistics";

export default {
	name: 'MetaInfo',
  data() {
    return {
      statId: '',
      metaInfoList: [], // 메타정보
    }
  },

  computed: {
    nonEmptyMetaInfoList() {
      return this.metaInfoList.filter(item => item.metaContents != null && item.metaContents != "");
    }
  },

  methods: {

    reload(statId) {
        if (this.statId === statId) return;

        this.statId = statId;
        this.selectMetaInfoList(statId);
    },

    // 메타정보 세팅
    async selectMetaInfoList (mgmNo) {
      const params = {
        mgmNo: mgmNo
      }

      const metaData = await api.metaInfoList(params);
      this.metaInfoList = metaData.data;
    },

  },
}
</script>

<style scoped>

</style>
